import { observer } from "mobx-react-lite";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { ProductSubscribeGate } from "../../products/subscribe_gate/ProductSubscribeGate";
import { getStandaloneSpaceId } from "../config";
import { standaloneProductRegistry } from "./StandaloneProductRegistry";
import { StandaloneProductSubscribeCta } from "./StandaloneProductSubscribeCta";

type Props = {
  row: MembershipProduct;
};

/** 独立站产品页未开通：复用平台海报布局，订阅后续走独立站购买弹窗 */
export const StandaloneProductSubscribeGate = observer((props: Props) => {
  const { row } = props;
  const spaceId = getStandaloneSpaceId();
  const membershipProducts = standaloneProductRegistry.catalogModules;
  return (
    <ProductSubscribeGate row={row}>
      <StandaloneProductSubscribeCta
        row={row}
        spaceId={spaceId}
        membershipProducts={membershipProducts}
      />
    </ProductSubscribeGate>
  );
});
